export enum RippleStates {
  NEW = "new",
  REMOVED = "removed",
}
